export default {
  getRecordList: '/courier/api/punish/reward'
}
